import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import {
  ReferBackToClientScreen,
  ReferBackToClientScreenProps,
} from './molecules/ReferBackToClientScreen';

type Props = {
  children: (props: ReferBackToClientScreenProps) => ReactElement;
};

export const ReferBackToClient: React.FC<Props> = ({
  children = (props) => <ReferBackToClientScreen {...props} />,
}) => {
  const { clientName } = useParams<ReferBackToClientScreenProps>();

  return children({ clientName });
};
